// core
import { Component, OnInit } from '@angular/core';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

@Component({
  selector: 'magic-link-expired',
  templateUrl: './magic-link-expired.component.html',
  styleUrls: ['./magic-link-expired.component.scss']
})
export class MagicLinkExpiredComponent implements OnInit {

  constructor(public partnerBrandService: PartnerBrandService) { }

  ngOnInit(): void {
  }

  gotToHomePage() {
    window.location.href = `https://${this.partnerBrandService.data.partner &&
      this.partnerBrandService.data.partner.companyInfo &&
      this.partnerBrandService.data.partner.companyInfo.BASE_DOMAIN}`;
  }

}
